import React from "react";
import styled from "styled-components";
import { IconSvg } from "monica-alexandria";
import { Timeline_Sales_Session_Changes } from "./Timeline_Sales_Session_Changes";

const TimelineSalesComment = styled.div`
    display: grid;
    grid-template-columns: 2.8rem minmax(0, 1fr);
    gap: 0.8rem;
    min-width: 0;
    padding: 0.8rem 1rem;
`;

const TimelineSalesCommentIcon = styled.div`
    display: grid;
    place-items: center;
    align-self: flex-start;
    width: 2.8rem;
    height: 2.8rem;
    border-radius: 50%;
    color: ${p => p.theme.color};
    background: ${p => p.theme.low};

    svg {
        width: 1.4rem;
        height: 1.4rem;
        fill: currentColor;
    }
`;

const TimelineSalesCommentContent = styled.div`
    display: grid;
    gap: 0.25rem;
    min-width: 0;
    font-family: "fontMedium", sans-serif;

    p {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

// Displays one genuine seller comment retained inside the Sales session.
export const Timeline_Sales_Session_Comment = (props) => {
    return (
        <TimelineSalesComment data-testid="timeline-sales-session-comment">
            <TimelineSalesCommentIcon title={props.t("comment")}>
                <IconSvg Icon="FbComment" />
            </TimelineSalesCommentIcon>
            <TimelineSalesCommentContent>
                <p>{props.event.comment}</p>
                <Timeline_Sales_Session_Changes event={props.event} t={props.t} />
            </TimelineSalesCommentContent>
        </TimelineSalesComment>
    );
};
